module.exports = __webpack_public_path__ + "static/media/location.b8d3ced8.svg";